import {
    SmartComposeInteraction,
    RejectionReason,
} from '@qas/smartcompose-tslibrary/dist/src/smartComposeInteraction';
SmartComposeInteraction;
export default function updateTelemetryForSuggestionOnSuggestionRejected(
    suggestionTelemetry: SmartComposeInteraction,
    rejectionReason: RejectionReason,
    nonMatchingCharacterTyped?: string
) {
    const now = new Date();
    suggestionTelemetry.suggestionRejectionTime = now;
    suggestionTelemetry.rejectionReason = rejectionReason;
    suggestionTelemetry.nonMatchingCharacterTyped = nonMatchingCharacterTyped;
    suggestionTelemetry.charactersTypedAfterRejection = '';
    suggestionTelemetry.charactersAcceptedAfterRejection = '';
}
